import { merge } from '../../../helper';

import type { CustomFile } from '../types';

import type { TypeUploadConfig, TypeUploadResultPromise } from './types';
import createUploadContext from './createUploadContext';
import createUploadController from './createUploadController';
import uploadFiles from './uploadFiles';

// ----------------------------------------------------------------------------

/*
 * The entry point for per-file uploads: one request per file, as many at a time as the
 * `concurrency` block allows.
 *
 * This is what the parallel, limited and sequential modes collapsed into — they were the same
 * engine reached through three names, differing only in the cap. Use `concurrency: { max: 1 }`
 * for sequential, `{ max: N }` for a throttled run, `{ enabled: false }` for no cap at all.
 * Batch is the one that stays separate, because a single request for every file is a different
 * shape, not a different number.
 */
function sendUpload(files: CustomFile[], config: TypeUploadConfig): TypeUploadResultPromise {
    const defConfig = merge({}, config);

    const context = createUploadContext(files);
    const promise = uploadFiles(files, defConfig, context);
    const controller = createUploadController(context);

    return { promise, controller };
}

// ----------------------------------------------------------------------------

export default sendUpload;
